var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKakaotalk = function SvgKakaotalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kakaotalk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#kakaotalk_svg__b)",
    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kakaotalk_svg__c)",
    d: "M10 4.972c-3.164 0-5.729 2.025-5.729 4.524 0 1.607 1.06 3.018 2.66 3.821l-.539 2.052a.144.144 0 0 0 .222.154l2.265-1.589c.37.058.746.087 1.121.087 3.164 0 5.73-2.026 5.73-4.525 0-2.498-2.566-4.524-5.73-4.524Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kakaotalk_svg__d)",
    d: "M7.656 8.72a.272.272 0 0 0 0-.545H5.993a.272.272 0 0 0 0 .544h.56v2.009a.272.272 0 0 0 .544 0V8.719h.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kakaotalk_svg__e)",
    d: "M11.606 10.432h-.774V8.447a.272.272 0 0 0-.544 0v2.202a.328.328 0 0 0 .328.328h.99a.273.273 0 0 0 0-.545Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kakaotalk_svg__f)",
    d: "M9.186 8.446a.424.424 0 0 0-.793 0l-.818 2.187a.272.272 0 0 0 .51.19l.13-.393h1.096a.256.256 0 0 0 .05-.005l.133.398a.273.273 0 1 0 .51-.19l-.818-2.187Zm-.802 1.477.406-1.225.406 1.225h-.812Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kakaotalk_svg__g)",
    d: "m14.099 10.533-.858-1.1.806-.779a.268.268 0 0 0-.373-.386l-1.005 1.046v-.867a.288.288 0 0 0-.576 0v2.281a.288.288 0 0 0 .575 0v-.741l.185-.179.798 1.074a.283.283 0 0 0 .507-.14.283.283 0 0 0-.06-.21Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kakaotalk_svg__b",
    x1: 0.039,
    x2: 19.015,
    y1: 19.961,
    y2: 0.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1A104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kakaotalk_svg__c",
    x1: 5.245,
    x2: 13.099,
    y1: 14.251,
    y2: 6.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#5C2627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kakaotalk_svg__d",
    x1: 4.982,
    x2: 10.912,
    y1: 11.015,
    y2: 5.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kakaotalk_svg__e",
    x1: 7.313,
    x2: 13.243,
    y1: 13.346,
    y2: 7.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kakaotalk_svg__f",
    x1: 6.395,
    x2: 12.325,
    y1: 12.428,
    y2: 6.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kakaotalk_svg__g",
    x1: 8.335,
    x2: 14.265,
    y1: 14.368,
    y2: 8.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFAF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kakaotalk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgKakaotalk;